{
  "title": "Plantillas de firma",
  "subtitle": "Una plantilla es un diseño de firma; las reglas deciden quién recibe cuál.",
  "templates": "Plantillas",
  "newTemplate": "Nueva plantilla",
  "loadError": "No se pudieron cargar las plantillas",
  "loadTemplateError": "No se pudo cargar la plantilla",
  "emptyTitle": "Aún no hay plantillas",
  "emptyBody": "Una plantilla es la firma HTML estampada en el correo saliente. Crea una para abrir el diseñador.",
  "save": "Guardar",
  "publish": "Publicar",
  "publishHint": "Compila este diseño y lo encola para el correo saliente. Guardar solo no cambia lo que ven los destinatarios.",
  "published": "Publicada como v{{version}}. Las firmas se actualizarán en unos segundos.",
  "publishFailed": "Error al publicar.",
  "preview": "Vista previa",
  "undo": "Deshacer",
  "redo": "Rehacer",
  "export": "Exportar",
  "exportHint": "Descarga este diseño como JSON para importarlo en otra plantilla o organización.",
  "exported": "Plantilla exportada.",
  "import": "Importar",
  "importHint": "Sustituye el lienzo por un diseño exportado. Guarda para conservarlo.",
  "imported": "Diseño importado. Guarda para conservarlo.",
  "importFailed": "Ese archivo no es una plantilla de firma válida.",
  "clone": "Clonar",
  "cloneHint": "Crea una copia de esta plantilla con el diseño actual.",
  "cloned": "Plantilla clonada.",
  "cloneFailed": "No se pudo clonar esa plantilla.",
  "cloneNameSuffix": " (copia)",
  "palette": "Bloques",
  "inspector": "Inspector",
  "canvas": "Lienzo",
  "unsaved": "Cambios sin guardar",
  "unsavedShort": "Sin guardar",
  "checking": "Comprobando…",
  "saved": "Plantilla guardada.",
  "saveError": "No se pudo guardar esa plantilla.",
  "saveFailed": "Error al guardar.",
  "statusDraft": "Borrador",
  "statusPublished": "Publicada",
  "statusArchived": "Archivada",
  "createTitle": "Nueva plantilla",
  "templateName": "Nombre de plantilla",
  "templateNamePlaceholder": "Corporativa — completa",
  "create": "Crear",
  "createError": "No se pudo crear la plantilla",
  "blockRow": "Fila",
  "blockColumn": "Columna",
  "blockText": "Texto",
  "blockImage": "Imagen",
  "blockSpacer": "Espaciador",
  "blockDivider": "Separador",
  "blockSocial": "Iconos sociales",
  "blockBanner": "Espacio de banner",
  "blockButton": "Botón",
  "blockDisclaimer": "Aviso legal",
  "blockGeneric": "Bloque",
  "addRow": "Añadir fila",
  "twoColumns": "Dos columnas",
  "threeColumns": "Tres columnas",
  "paletteHelp": "Las columnas se añaden y redimensionan desde el inspector de la fila. Las filas no pueden ir dentro de una columna: las tablas anidadas son donde Outlook falla al renderizar.",
  "deleteBlock": "Eliminar bloque",
  "duplicateBlock": "Duplicar bloque",
  "noSelection": "Selecciona un bloque para editar sus propiedades.",
  "content": "Contenido",
  "style": "Estilo",
  "layout": "Diseño",
  "previewTitle": "Vista previa",
  "previewAs": "Vista previa como",
  "previewNamed": "Vista previa — {{name}}",
  "previewSignature": "Vista previa de la firma",
  "closePreview": "Cerrar vista previa",
  "compilerWarnings_one": "{{count}} aviso del compilador",
  "compilerWarnings_other": "{{count}} avisos del compilador",
  "compilerWarningsHint": "Del mismo compilador que se ejecuta al publicar. Los bloques con aviso se marcan en el lienzo.",
  "sketchBadge": "Boceto",
  "sketchHint": "Solo el diseño: el espaciado, las tipografías y las peculiaridades de Outlook no se reproducen aquí. Abre la vista previa para ver cómo queda el correo.",
  "canvasEmpty": "Arrastra un bloque de la paleta o haz clic en uno para añadirlo.",
  "emptyColumn": "Columna vacía",
  "reorderRow": "Reordenar fila",
  "reorderBlock": "Reordenar {{block}}",
  "markerExternalOnly": "solo externos",
  "markerNewMessagesOnly": "solo mensajes nuevos",
  "markerConditions_one": "{{count}} condición",
  "markerConditions_other": "{{count}} condiciones",
  "placeholderImageNoSource": "Imagen — sin origen",
  "placeholderImageMerge": "Imagen — origen con campo de combinación",
  "placeholderSocialEmpty": "Iconos sociales — ninguno añadido",
  "placeholderBanner": "Banner de campaña — el arte proviene de la campaña activa al enviar",
  "sampleProfilePhotoAlt": "Foto de perfil de ejemplo",
  "sampleProfilePhotoTitle": "Foto de perfil de ejemplo: al enviar se usa la foto real de cada remitente",
  "theme": "Tema",
  "themeHint": "Se aplica a toda la firma. Solo tipografías web seguras: Outlook no carga fuentes web y Gmail las elimina, así que una firma que dependa de ellas se ve distinta para la mayoría de lectores.",
  "appliesTo": "Se aplica a",
  "font": "Fuente",
  "baseSizePx": "Tamaño base (px)",
  "textColour": "Color del texto",
  "linkColour": "Color del enlace",
  "background": "Fondo",
  "backgroundHint": "Suele ser mejor dejarlo sin definir. Los clientes en modo oscuro recolorean paneles claros, y así una firma acaba como una caja blanca en un hilo oscuro.",
  "clearBackground": "Quitar fondo",
  "maxWidthPx": "Ancho máximo (px)",
  "maxWidthPxHint": "Déjalo en blanco para Auto: la tabla de la firma no tiene tope.",
  "maxWidthBannerHint": "Déjalo en blanco para Auto: el banner se adapta al ancho de la firma.",
  "hideWhenNoPhoto": "Ocultar si el remitente no tiene foto",
  "hideWhenBlank": "Ocultar si sus campos están vacíos",
  "hideWhenNoPhotoHint": "Las fotos de perfil siempre omiten el retrato (y su columna) cuando el directorio no tiene ninguna: un hueco vacío nunca es útil.",
  "hideWhenBlankHint": "Evita que un usuario sin móvil termine con una «M:» huérfana y un separador suelto.",
  "includeInReplies": "Incluir en respuestas y reenvíos",
  "includeInRepliesHint": "Desactívalo para logos y avisos legales, que se convierten en ruido en el cuarto mensaje de un hilo.",
  "recipients": "Destinatarios",
  "audienceEveryone": "Todos",
  "audienceExternalOnly": "Solo externos",
  "showOnlyWhen": "Mostrar solo cuando",
  "visibleWhenEmptyHint": "Siempre visible. Añade una condición para limitar este bloque a algunos usuarios.",
  "alignment": "Alineación",
  "alignLeft": "Izquierda",
  "alignCentre": "Centro",
  "alignRight": "Derecha",
  "paddingTop": "Relleno superior",
  "paddingBottom": "Relleno inferior",
  "columns": "Columnas",
  "columnsHint": "Las columnas se añaden y quitan aquí en lugar de arrastrarse, porque una columna solo tiene sentido dentro de su fila.",
  "columnWidth": "Ancho de columna {{n}}",
  "placeholderAuto": "Auto",
  "placeholderTheme": "Tema",
  "removeColumn": "Quitar columna {{n}}",
  "editColumn": "Editar",
  "addColumn": "Añadir columna",
  "widthPx": "Ancho (px)",
  "widthPxHint": "Si se deja en blanco, la columna comparte el espacio restante. Los anchos fijos resisten mejor el motor de Word que los porcentajes.",
  "verticalAlign": "Alineación vertical",
  "alignTop": "Arriba",
  "alignMiddle": "Medio",
  "alignBottom": "Abajo",
  "padLeft": "Relleno izquierdo",
  "padRight": "Relleno derecho",
  "padTop": "Relleno superior",
  "padBottom": "Relleno inferior",
  "text": "Texto",
  "sizePx": "Tamaño (px)",
  "lineHeight": "Interlineado",
  "colour": "Color",
  "bold": "Negrita",
  "italic": "Cursiva",
  "link": "Enlace",
  "disclaimerText": "Texto del aviso legal",
  "imageUrl": "URL de la imagen",
  "imageUrlHint": "HTTPS absoluta, o {{photoToken}} para la foto de directorio de cada remitente. Gmail no muestra un adjunto incrustado, así que las imágenes siempre se alojan.",
  "useProfilePhoto": "Usar foto de perfil",
  "chooseFromLibrary": "Elegir de la biblioteca",
  "clear": "Borrar",
  "profilePhotoHint": "Al enviar se convierte en la foto del remitente. Quien no tenga una pierde el retrato y su columna por completo: nunca una imagen rota ni un hueco del tamaño de una cara.",
  "heightPx": "Alto (px)",
  "unlockAspect": "Desbloquear proporción",
  "lockAspect": "Bloquear proporción",
  "autoSize": "Auto",
  "autoProfileHint": "Fija {{size}}×{{size}} para el hueco del retrato.",
  "autoNaturalHint": "Usa el tamaño natural de la imagen (con tope para firmas).",
  "autoNeedSource": "Añade una URL de imagen o elige una de la biblioteca primero.",
  "autoNeedHttps": "Auto necesita una URL https:// para medir.",
  "autoMeasureFailed": "No se pudo leer el tamaño de esa imagen. Comprueba que la URL carga en el navegador.",
  "aspectLocked": "Proporción bloqueada: al cambiar un lado se escala el otro.",
  "aspectUnlocked": "Proporción desbloqueada: ancho y alto se editan por separado.",
  "dimensionsHint": "Ambas dimensiones se emiten como atributos HTML. Sin ellas, el motor de Word reescala la imagen en cualquier pantalla por encima de 96 DPI, que es la mayoría.",
  "altText": "Texto alternativo",
  "profilePhotoAlt": "Foto de perfil",
  "frame": "Marco",
  "frameHint": "Bordes y sombras suaves aparecen en clientes modernos. Outlook clásico conserva el borde e ignora el radio y la sombra.",
  "frameColour": "Color del marco",
  "frameNone": "Ninguno",
  "frameThin": "Fino",
  "frameThick": "Grueso",
  "frameRounded": "Redondeado",
  "frameCircle": "Círculo",
  "frameSoftShadow": "Sombra suave",
  "effect": "Efecto",
  "effectHint": "Genera un GIF animado seguro para correo. Outlook de escritorio suele congelarse en la imagen final; Gmail y otros reproducen el movimiento.",
  "effectProfileHint": "Los efectos requieren una imagen de biblioteca alojada o una URL HTTPS — no un campo de fusión de foto de perfil.",
  "effectNeedHttps": "Añada primero una imagen https:// o elija una de la biblioteca.",
  "effectConverting": "Convirtiendo a GIF animado…",
  "effectApplyFailed": "No se pudo aplicar ese efecto.",
  "effectNone": "Ninguno",
  "effectWhipFlip": "Whip Flip",
  "effectDottedGloom": "Dotted Gloom",
  "effectGlowSway": "Glow Sway",
  "effectInvertedChaos": "Inverted Chaos",
  "effectHaloBlur": "Halo Blur",
  "effectBlur": "Blur",
  "effectMirror": "Mirror",
  "effectFadeOut": "Fade Out",
  "effectLowExposure": "Low Exposure",
  "effectColorsOff": "Colors Off",
  "networkPlaceholder": "Red",
  "removeIcon": "Quitar {{name}}",
  "iconFallback": "icono",
  "profileUrl": "URL del perfil",
  "profileUrlPlaceholder": "URL del perfil — puede ser un campo de combinación",
  "iconImageUrl": "URL de la imagen del icono",
  "iconImageUrlPlaceholder": "URL de la imagen del icono",
  "addIcon": "Añadir icono",
  "socialIconsHint": "Un icono cuyo enlace queda vacío se omite solo, así que un usuario sin LinkedIn no recibe un icono muerto.",
  "platformLabel": "Plataforma",
  "platformLinkedIn": "LinkedIn",
  "platformX": "X",
  "platformFacebook": "Facebook",
  "platformInstagram": "Instagram",
  "platformYouTube": "YouTube",
  "platformTikTok": "TikTok",
  "platformThreads": "Threads",
  "platformGitHub": "GitHub",
  "platformWhatsApp": "WhatsApp",
  "platformWebsite": "Sitio web",
  "platformOther": "Otro",
  "chooseIconFromLibrary": "Elegir icono de la biblioteca",
  "useDefaultIcon": "Usar icono predeterminado",
  "iconOverrideHint": "Déjalo vacío solo en Otro sin imagen. Los predeterminados son URL HTTPS del producto.",
  "iconAlt": "Texto alternativo",
  "moveIconUp": "Mover icono a la izquierda",
  "moveIconDown": "Mover icono a la derecha",
  "iconMustBeHttps": "La imagen del icono debe ser una URL https:// para aparecer en el correo.",
  "spacingPx": "Espaciado (px)",
  "bannerSlotHint": "El arte y el enlace vienen de la campaña activa al enviar el mensaje, para que marketing pueda empezar y acabar un banner sin reabrir esta plantilla.",
  "label": "Etiqueta",
  "url": "URL",
  "buttonWidth": "Ancho",
  "buttonHeight": "Alto",
  "cornerRadius": "Radio de esquina",
  "fontSize": "Tamaño de fuente",
  "thicknessPx": "Grosor (px)",
  "dividerHint": "Se dibuja como una celda de tabla rellena en lugar de un hr, que los clientes estilizan de forma inconsistente.",
  "insertField": "Insertar campo",
  "searchFields": "Buscar campos",
  "noFieldMatch": "Ningún campo coincide.",
  "mergeFieldProblem": "Problema con el campo de combinación",
  "emptyText": "Texto vacío",
  "groupThisTenant": "Este inquilino",
  "groupUser": "Usuario",
  "groupOrganisation": "Organización",
  "groupCampaign": "Campaña",
  "fieldDisplayName": "Nombre para mostrar",
  "fieldGivenName": "Nombre",
  "fieldSurname": "Apellidos",
  "fieldJobTitle": "Cargo",
  "fieldDepartment": "Departamento",
  "fieldPrimaryEmail": "Correo electrónico",
  "fieldPhotoUrl": "Foto de perfil (URL de imagen)",
  "fieldMobilePhone": "Móvil",
  "fieldBusinessPhone": "Teléfono",
  "fieldOfficeLocation": "Oficina",
  "fieldCity": "Ciudad",
  "fieldCountry": "País",
  "fieldTenantName": "Nombre de la organización",
  "fieldTenantSlug": "Slug de la organización",
  "fieldCampaignAlt": "Texto alternativo del banner",
  "fieldCampaignUrl": "Enlace del banner",
  "dirtyPreviewTitle": "Mostrando la última versión guardada",
  "dirtyPreviewBody": "La vista previa renderiza lo almacenado, no lo que hay en el lienzo. Guarda para actualizarla.",
  "desktopWidth": "Escritorio 600px",
  "mobileWidth": "Móvil 320px",
  "darkMode": "Modo oscuro",
  "darkModeTooltip": "Solo una aproximación: los colores se invierten y rotan, que no es lo que hace ningún cliente real. Outlook, Gmail y Apple Mail recolorean de forma distinta y algunos dejan los fondos claros. Úsalo para detectar una firma que desaparece, no para dar por buenos los colores.",
  "darkModeHint": "Aproximado. Los clientes reales recolorean distinto: trátalo como una prueba rápida, no como una prueba definitiva.",
  "renderWarnings": "Avisos de renderizado",
  "renderError": "No se pudo renderizar la vista previa",
  "iframeTitle": "Vista previa de la firma — {{context}}",
  "contextNew": "Nuevo",
  "contextReply": "Respuesta",
  "contextNewExternal": "Nuevo (externo)",
  "contextReplyExternal": "Respuesta (externo)",
  "contextGmail": "Gmail",
  "contextAddIn": "Complemento",
  "contextPlainText": "Texto sin formato",
  "testAs": "Probar como",
  "testAsHint": "Los campos de combinación y la foto vienen de este buzón. Bórralo para usar la persona de ejemplo.",
  "loadingMailboxes": "Cargando buzones…",
  "samplePerson": "Persona de ejemplo",
  "noMailboxMatch": "Ningún buzón coincide con esa búsqueda.",
  "selectedMailbox": "Buzón seleccionado",
  "excludedSuffix": " (excluido)",
  "gmailBudget": "Presupuesto de tamaño de Gmail",
  "gmailCharacters": "{{used}} / {{max}} caracteres",
  "gmailWillTruncate": "Gmail truncará",
  "gmailNearLimit": "Cerca del límite",
  "assetPickerTitle": "Elegir una imagen",
  "assetPickerHint": "Imágenes alojadas, que descarga el cliente de correo del destinatario. PNG, JPEG, GIF o WebP.",
  "uploadImage": "Subir una imagen",
  "uploadWarningTitle": "Subida, pero conviene revisarla",
  "assetsEmpty": "Aún no hay imágenes. Sube una y aparecerá aquí para todas las firmas de este inquilino.",
  "alreadyInLibrary": "Esa imagen ya estaba en la biblioteca, así que se usó la existente.",
  "uploadFailed": "No se pudo subir esa imagen.",
  "deleteFailedTitle": "No eliminada",
  "deleteFailed": "No se pudo eliminar esa imagen.",
  "deleteAsset": "Eliminar {{name}}",
  "useThisAsset": "Usar esta"
}
